<template>
  <div class="project-basic-tab" style="margin-top: 5px">
    <el-form :inline="true" label-width="100px" label-position="right" style="width: 750px">
      <div class="inner-row">
        <el-form-item :label="$t('Project.ProjectNo')" required="required">
          <el-input v-model="form.projectNo" :disabled="true" style="width: 200px" no="1" />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectName')" class="custom" required="required">
          <el-input v-model="form.projectName" :disabled="isEdit" style="width: 200px" no="2" />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectStatus')" class="custom">
          <el-select v-model="form.projectStatus" disabled="disabled" style="width: 200px" no="3">
            <el-option
              v-for="(item,index) in statusList"
              :key="index"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="Number(item.code)"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.CustomerName')" required="required">
          <cargo-advance-select
            style="width: 200px"
            filterable
            :actionable-option="item=>item.active"
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="Number(form.partener)||''"
            :method-params="{customer: true, active: true}"
            :cache="true"
            :disabled="isEdit"
            tag-name="chineseName"
            no="4"
            @parentCallBack="item=>form.partener=item.value"
          />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectCycle')" class="custom" style="margin-right: 30px" required="required">
          <el-date-picker v-model="form.dateStart" type="date" style="width:130px" :disabled="isEdit" no="5" />
          <span style="color: #404144;">- </span><el-date-picker v-model="form.dateEnd" type="date" style="width:130px" :disabled="isEdit" no="6" />
        </el-form-item>
        <el-form-item :label="$t('Project.SettleCurrency')" class="custom" required="required">
          <cargo-advance-select
            style="width: 200px"
            filterable
            :select-type="selectTypeNames.basic_data_Currency"
            :default-value="form.settleCurrency||''"
            :disabled="isEdit"
            no="7"
            @parentCallBack="item=>form.settleCurrency=item.value"
          />
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.ExpectIncome')">
          <el-input-number v-model="form.expectIncome" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="8" @change="checkExpectProfitTate" />
        </el-form-item>
        <el-form-item :label="$t('Project.RealIncome')" class="custom">
          <el-input-number v-model="form.realIncome" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="9" @change="checkRealProfitTate" />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectManager')" class="custom" required="required">
          <cargo-advance-select
            :actionable-option="item=>item.active"
            :select-type="selectTypeNames.basic_data_User"
            :url="URL.sys.getUsersByPrivilegeDetail"
            :cache="false"
            :method-params="{officeId:$store.getters.currentOfficeId}"
            filterable
            :default-value="Number(form.projectManager)||''"
            style="width:200px;"
            :disabled="isEdit"
            no="10"
            @parentCallBack="manageCallback"
          />
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.ExpectCost')">
          <el-input-number v-model="form.expectCost" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="11" @change="checkExpectCostToTal" />
        </el-form-item>
        <el-form-item :label="$t('Project.RealCost')" class="custom">
          <el-input-number v-model="form.realCost" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="12" @change="checkRealCostToTal" />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectDepartment')" class="custom" required="required">
          <cargo-advance-select
            style="width: 200px"
            filterable
            :disabled="true"
            :select-type="selectTypeNames.basic_data_Department"
            :default-value="Number(form.projectDepartment)||''"
            no="13"
            @parentCallBack="item=>form.projectDepartment=item.value"
          />
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.ExpectExpense')">
          <el-input-number v-model="form.expectExpense" :controls="false" :precision="2" :disabled="isEdit" style="width: 200px" no="14" @change="checkExpectCostToTal" />
        </el-form-item>
        <el-form-item :label="$t('Project.RealExpense')" class="custom">
          <el-input-number v-model="form.realExpense" :controls="false" :precision="2" :disabled="isEdit" style="width: 200px" no="15" @change="checkRealCostToTal" />
        </el-form-item>
        <el-form-item :label="$t('Project.ProjectOffice')" class="custom" required="required">
          <cargo-advance-select
            style="width: 200px"
            filterable
            :select-type="selectTypeNames.basic_data_Office"
            :default-value="Number(form.projectOffice)||''"
            :disabled="true"
            no="16"
            @parentCallBack="item=>form.projectOffice=item.value"
          />
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.ExpectTotalCost')">
          <el-input-number v-model="otherTotal.expectTotalCost" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="17" />
        </el-form-item>
        <el-form-item :label="$t('Project.RealTotalCost')" class="custom">
          <el-input-number v-model="otherTotal.realTotalCost" :controls="false" :precision="2" :disabled="true" style="width: 200px" no="18" />
        </el-form-item>
        <el-form-item :label="$t('Project.ReceiveStatus')" class="custom">
          <el-select v-model="form.receiveStatus" :disabled="isEdit" style="width: 200px" no="19">
            <el-option
              v-for="(item,index) in receiveStatusList"
              :key="index"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="Number(item.code)"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.ExpectProfitTate')">
          <el-input-number v-model="form.expectProfitTate" :controls="false" :precision="2" :disabled="true" style="width: 186px;border: none" no="20" /><span style="color: #545557">%</span>
        </el-form-item>
        <el-form-item :label="$t('Project.RealProfitTate')" class="custom">
          <el-input-number v-model="form.realProfitTate" :controls="false" :precision="2" :disabled="true" style="width: 186px;border: none" no="21" /><span style="color: #545557">%</span>
        </el-form-item>
        <el-form-item :label="$t('Project.PayStatus')" class="custom">
          <el-select v-model="form.payStatus" :disabled="isEdit" style="width: 200px" no="22">
            <el-option
              v-for="(item,index) in payStatusList"
              :key="index"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="Number(item.code)"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="inner-row">
        <el-form-item :label="$t('Project.Remarks')">
          <el-input v-model="form.remarks" type="textarea" :disabled="isEdit" style="width: 300px" no="23" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>

import cargoArea from '@/components/Cargo/Common/cargoArea'
import { cacheName, cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ProjectManageState from '@/class/cargo/model/parameters/ProjectManageState.js'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { detail
} from '@/api/projectManage/project'
import { getDepIdAndOffIdByUserOrDep
} from '@/api/user'
// import Style from "ag-grid-enterprise/src/exporter/files/xml/styles/style";
export default {
  name: 'BasicTab',
  components: { cargoAdvanceSelect, cargoArea },
  data() {
    return {
      defaultDepartment: {
        depId: 0,
        userId: 0
      },
      canUseManage: false,
      selectTypeNames: TYPE_NAMES,
      isNewDelegation: 0,
      initialForm: {},
      URL,
      statusList: ProjectManageState.PROJECT_STATE_DETAIL, // 状态下拉
      payStatusList: ProjectManageState.PROJECT_PAY_STATE, // 状态下拉
      receiveStatusList: ProjectManageState.PROJECT_REC_STATE, // 状态下拉
      isEdit: false,
      partnerManagementMode: 0,
      oprationType: 1,
      form: {
        uuid: '',
        projectNo: '',
        projectName: '',
        projectStatus: 0,
        partener: 0,
        dateStart: '',
        dateEnd: '',
        settleCurrency: 0,
        expectIncome: 0.00,
        realIncome: 0.00,
        projectManager: 0,
        expectCost: 0.00,
        realCost: 0.00,
        projectDepartment: 0,
        expectExpense: 0.00,
        realExpense: 0.00,
        projectOffice: 0,
        receiveStatus: 0,
        expectProfitTate: 0,
        realProfitTate: 0.00,
        payStatus: 0,
        remarks: '',
        branchId: 0
      },
      otherTotal: {
        expectTotalCost: 0.00,
        realTotalCost: 0.00
      },
      initForm: {
        uuid: '',
        projectNo: '',
        projectName: '',
        projectStatus: 0,
        partener: 0,
        dateStart: '',
        dateEnd: '',
        settleCurrency: 0,
        expectIncome: 0.00,
        realIncome: 0.00,
        projectManager: 0,
        expectCost: 0.00,
        realCost: 0.00,
        projectDepartment: 0,
        expectExpense: 0.00,
        realExpense: 0.00,
        projectOffice: 0,
        receiveStatus: 0,
        expectProfitTate: 0,
        realProfitTate: 0.00,
        payStatus: 0,
        remarks: '',
        branchId: 0
      }
    }
  },
  computed: {
    url() {
      return URL
    },
    readonly() {
      return !this.action || this.action === 'look'
    }
  },
  async created() {
    // this.initialForm = {...this.form}
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.partnerManagementMode = Number(cache.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
  },
  methods: {
    getDetail(uuid) {
      detail(uuid).then(res => {
        this.form = res.data
        this.otherTotal.expectTotalCost = this.form.expectCost + this.form.expectExpense
        this.otherTotal.realTotalCost = this.form.realCost + this.form.realExpense
      }).catch(() => {
        console.log('get project detaul faild')
      })
    },
    manageCallback(item) {
      if (item.value === '') {
        this.form.projectManager = item.value
        this.form.projectDepartment = item.defaultDepId
        this.form.projectOffice = item.defaultOfficeId
        return
      }
      this.form.projectManager = item.value
      if (item.defaultDepId === undefined || item.defaultDepId === 0 || item.defaultOfficeId === undefined || item.defaultOfficeId === 0) {
        // 没有默认部门，获取当前部门根据用户id
        this.defaultDepartment.depId = item.defaultDepId
        this.defaultDepartment.userId = item.value
        getDepIdAndOffIdByUserOrDep(this.defaultDepartment).then(res => {
          if (res.data === '' || res.data === null) {
            this.form.projectDepartment = 0
            this.form.projectOffice = 0
          } else {
            this.form.projectDepartment = res.data.departmentId
            this.form.projectOffice = res.data.officeId
          }
        })
      } else {
        this.form.projectDepartment = item.defaultDepId
        this.form.projectOffice = item.defaultOfficeId
      }
    },
    // 预计成本改变事件
    checkExpectCostToTal() {
      this.otherTotal.expectTotalCost = this.form.expectCost + this.form.expectExpense
      if (!this.otherTotal.expectTotalCost || this.otherTotal.expectTotalCost === 0) {
        this.form.expectProfitTate = 100
      } else if (!this.form.expectIncome || this.form.expectIncome === 0) {
        this.form.expectProfitTate = 0
      } else {
        this.form.expectProfitTate = (1 - this.otherTotal.expectTotalCost / this.form.expectIncome) * 100
      }
    },
    // 预计成本改变事件
    checkRealCostToTal() {
      this.otherTotal.realTotalCost = this.form.realCost + this.form.realExpense
      if (!this.otherTotal.realTotalCost || this.otherTotal.realTotalCost === 0) {
        this.form.realProfitTate = 100
      } else if (!this.form.realIncome || this.form.realIncome === 0) {
        this.form.realProfitTate = 0
      } else {
        this.form.realProfitTate = (1 - this.otherTotal.realTotalCost / this.form.realIncome) * 100
      }
    },
    // 预计利润率
    checkExpectProfitTate() {
      if (!this.otherTotal.expectTotalCost || this.otherTotal.expectTotalCost === 0) {
        this.form.expectProfitTate = 100
      } else if (!this.form.expectIncome || this.form.expectIncome === 0) {
        this.form.expectProfitTate = 0
      } else {
        this.form.expectProfitTate = (1 - this.otherTotal.expectTotalCost / this.form.expectIncome) * 100
      }
    },
    // 实际利润率
    checkRealProfitTate() {
      if (!this.otherTotal.realTotalCost || this.otherTotal.realTotalCost === 0) {
        this.form.realProfitTate = 100
      } else if (!this.form.realIncome || this.form.realIncome === 0) {
        this.form.realProfitTate = 0
      } else {
        this.form.realProfitTate = (1 - this.otherTotal.realTotalCost / this.form.realIncome) * 100
      }
    },
    // 同步费用
    asyncCharge(data) {
      this.form.realIncome = data.realIncome
      this.form.realProfitTate = data.realProfitTate
      this.form.expectIncome = data.expectIncome
      this.form.realCost = data.realCost
      this.form.expectProfitTate = data.expectProfitTate
      this.form.expectCost = data.expectCost
      this.checkExpectCostToTal()
      this.checkRealCostToTal()
    }
  }
}
</script>

<style lang="scss">
.project-basic-tab{
}
</style>
